import React from 'react';

interface LiftNotificationModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const LiftNotificationModal: React.FC<LiftNotificationModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="modal-content" style={{ maxWidth: '500px' }}>
        <div className="modal-header" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <h3 style={{ margin: 0, textAlign: 'center', width: '100%' }}>Informacja o systemie LIFT</h3>
        </div>
        <div className="modal-body" style={{ padding: '20px' }}>
          <p style={{ fontSize: '16px', lineHeight: '1.5', marginBottom: '20px' }}>
            Cena systemu LIFT dotyczy jednej strony. W przypadku systemu LIFT z dwóch stron prosimy o kontakt w celu wykonania wyceny indywidualnej. <br /><br />Wybór systemu LIFT jako wariantu otwierania z przodu automatycznie ustawi w konfiguratorze otwieranie standardowe (do boku) po stronie tylnej wkładu.
          </p>
        </div>
        <div className="modal-buttons" style={{ padding: '0 20px 20px', textAlign: 'center' }}>
          <button 
            className="btn btn-primary" 
            onClick={onClose}
            style={{ 
              padding: '10px 30px', 
              fontSize: '16px',
              backgroundColor: 'var(--accent)',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default LiftNotificationModal;
